import { render, staticRenderFns } from "./ServiceComponents.vue?vue&type=template&id=313c8ed6"
import script from "./ServiceComponents.vue?vue&type=script&lang=js"
export * from "./ServiceComponents.vue?vue&type=script&lang=js"
import style0 from "./ServiceComponents.vue?vue&type=style&index=0&id=313c8ed6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports